import TextDecorationComponent from './text-decoration.component'

const TextDecorationModule = angular.module('cdbl.text-decoration', [

])
  .component('cdblTextDecoration', TextDecorationComponent)
  .name

export default TextDecorationModule
